import templateHandler from './templateHandler';

export default {
  template: templateHandler
};
